import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { App } from '@/app/App';
import { SessionProvider } from '@/app/session';
import { ThemeProvider } from '@/app/theme';
import '@/ui/styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: true, staleTime: 2000 },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element is missing');

// Vite exposes the configured public base at runtime. Keeping the router on the
// same base lets the normal on-prem app run at `/` while the public demo can be
// mounted safely at `/demo/app/` without producing root-level links.
const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '') || undefined;
const isSubpathBuild = import.meta.env.BASE_URL !== '/';

const app = <App />;
const router = isSubpathBuild ? (
  <HashRouter>{app}</HashRouter>
) : (
  <BrowserRouter basename={routerBasename}>{app}</BrowserRouter>
);

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <SessionProvider>
          {router}
        </SessionProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
